import React from 'react';
import { string, arrayOf, shape, oneOf } from 'prop-types';

import SearchModalContent from '../../sidebar/components/search-modal-content';
import GeneralModal from '../../modal/general-modal';

const namespace = 'ui-search-vehicle-body-viewmore';

/**
 * VehicleBodyViewMore component renders a list item containing a modal with vehicle body options.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.text - The text to be displayed on the modal label.
 * @param {Object} props.modal - The modal configuration object.
 * @param {string} props.modal.id - The unique identifier for the modal.
 * @param {string} props.modal.type - The type of modal, either 'DEFAULT' or 'WITH_SEARCH'.
 * @param {'DEFAULT'|'WITH_SEARCH'} [props.modal.type] - The type of modal, either 'DEFAULT' or 'WITH_SEARCH'.
 * @param {string} props.modal.title - The title of the modal.
 * @param {string} props.modal.image - The image URL to be used in the modal.
 * @param {Object} props.modal.multi_selection - The multi-selection configuration object.
 * @param {Array<{id: string, name: string, url: string}>} props.modal.values - The array of values to be displayed in the modal.
 * @returns {React.JSX.Element} The rendered component.
 */
const VehicleBodyViewMore = ({ text, modal }) => (
  <li className={namespace}>
    <GeneralModal
      modalClassName={`${namespace}__modal`}
      label={text}
      modalUrl="#filter"
      url=""
      type="small"
      withLink
      modalTitle={modal.title}
    >
      <SearchModalContent {...modal} values={modal.values.map((value) => ({ ...value, image: modal.image }))} />
    </GeneralModal>
  </li>
);

VehicleBodyViewMore.propTypes = {
  modal: shape({
    id: string.isRequired,
    type: oneOf(['DEFAULT', 'WITH_SEARCH']),
    title: string.isRequired,
    image: string.isRequired,
    values: arrayOf(
      shape({
        id: string.isRequired,
        name: string.isRequired,
        url: string.isRequired,
      }),
    ),
  }),
  text: string.isRequired,
};

export default VehicleBodyViewMore;
